import { render, staticRenderFns } from "./FileExaminationComments.vue?vue&type=template&id=1b16622a"
import script from "./FileExaminationComments.vue?vue&type=script&lang=ts"
export * from "./FileExaminationComments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports